import React from 'react';
import { Link } from 'react-router-dom';
import { Post } from '../../types';

interface FeaturedContentProps {
  latestPosts: Post[];
  featuredUsers: any[]; // TODO: 定义 User 类型
}

const FeaturedContent: React.FC<FeaturedContentProps> = ({ latestPosts, featuredUsers }) => {
  return (
    <div className="bg-gray-50 py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* 最新文章 */}
        <div className="mb-12">
          <h2 className="text-3xl font-extrabold text-gray-900 mb-8">最新文章</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {latestPosts.map((post) => (
              <div key={post.id} className="bg-white overflow-hidden shadow rounded-lg">
                <div className="p-6">
                  <h3 className="text-lg font-medium text-gray-900">
                    <Link to={`/community/posts/${post.id}`}>{post.title}</Link>
                  </h3>
                  <p className="mt-2 text-sm text-gray-500 line-clamp-3">{post.content}</p>
                  <div className="mt-4 flex items-center">
                    <div className="flex-shrink-0">
                      <img
                        className="h-10 w-10 rounded-full"
                        src={post.author.avatar || 'https://via.placeholder.com/40'}
                        alt={post.author.name}
                      />
                    </div>
                    <div className="ml-3">
                      <p className="text-sm font-medium text-gray-900">{post.author.name}</p>
                      <p className="text-sm text-gray-500">{new Date(post.createdAt).toLocaleDateString()}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 推荐人才 */}
        <div>
          <h2 className="text-3xl font-extrabold text-gray-900 mb-8">推荐人才</h2>
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {featuredUsers.map((user) => (
              <div key={user.id} className="bg-white overflow-hidden shadow rounded-lg">
                <div className="p-6">
                  <div className="flex items-center">
                    <div className="flex-shrink-0">
                      <img
                        className="h-16 w-16 rounded-full"
                        src={user.avatar || 'https://via.placeholder.com/64'}
                        alt={user.name}
                      />
                    </div>
                    <div className="ml-4">
                      <h3 className="text-lg font-medium text-gray-900">
                        <Link to={`/profile/${user.id}`}>{user.name}</Link>
                      </h3>
                      <p className="text-sm text-gray-500">{user.bio}</p>
                    </div>
                  </div>
                  <div className="mt-4">
                    <Link
                      to={`/profile/${user.id}`}
                      className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-primary-700 bg-primary-100 hover:bg-primary-200"
                    >
                      查看详情
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturedContent; 